import { getRedirectUriQueryParam } from '../../../../utils/url';

export function getReferrer(applicationId: number): string {
  return getRedirectUriQueryParam() ?? `/applications/${applicationId}`;
}
